import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b9fc3538"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b9fc3538&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9fc3538')) {
      api.createRecord('b9fc3538', component.options)
    } else {
      api.reload('b9fc3538', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b9fc3538", function () {
      api.rerender('b9fc3538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/platformCashBackAudit/edit/index.vue"
export default component.exports